



















































































































































































































import { Component, Watch } from "vue-property-decorator"
import api from "../../api/index"
import Box from "../components/Box.vue"
import Lists from "../components/Lists.vue"
import ConfirmModal from "../components/ConfirmModal.vue"
import DelegationForm from "../components/forms/DelegationForm.vue"
import {perPageOptions} from '@/constants/ListOptions'

@Component({
  components: {
    Box,
    ConfirmModal,
    DelegationForm
  },
})
export default class DelegationProfile extends Lists {
  delegation: { [key: string]: any } = { id: null }
  loading = false

  editedDelegation: any = {}
  formActive = false
  confirmModalActive = false

  perPageOptions = perPageOptions
  usersTotalPages = 0
  usersCurrentPage = 1
  usersPerPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0]

  condominiumsTotalPages = 0
  condominiumsCurrentPage = 1
  condominiumsPerPage = 10

  async mounted() {
    await api.setToken()
    await this.getDelegation()
    this.addBreadcrumb()
  }

  @Watch('usersPerPage')
  perPageChanged() {
    localStorage.setItem('resultsPerListPage', this.usersPerPage.toString())
    this.computePagination()
  }

  computePagination() {
    if (this.delegation.users && this.delegation.users.length > this.usersPerPage) {
      this.usersTotalPages = Math.ceil(this.delegation.users.length / this.usersPerPage)
    } else {
      this.usersTotalPages = 0
    }
    const condos = this.delegation.condominiums || []
    if (condos.length > this.condominiumsPerPage) {
      this.condominiumsTotalPages = Math.ceil(condos.length / this.condominiumsPerPage)
    } else {
      this.condominiumsTotalPages = 0
    }
  }

  async getDelegation() {
    try {
      this.loading = true
      const res = await api.get(`bo/delegations/${this.$route.params.delegationId}`)
      this.delegation = res.data
      this.editedDelegation = JSON.parse(JSON.stringify(this.delegation))
      this.computePagination()
    } catch (e) {
      if (e.response && e.response.status === 401) {
        console.log(e.response.status)
      }
    } finally {
      this.loading = false
    }
  }

  get usersList() {
    if (!this.delegation.id || !this.delegation.users || this.delegation.users.length < 1) return []
    const startIndex = (this.usersCurrentPage - 1) * this.usersPerPage
    return this.delegation.users.slice(startIndex, startIndex + this.usersPerPage)
  }

  get condominiumsList() {
    const condos = this.delegation.condominiums || []
    if (condos.length < 1) return []
    const startIndex = (this.condominiumsCurrentPage - 1) * this.condominiumsPerPage
    return condos.slice(startIndex, startIndex + this.condominiumsPerPage)
  }

  initEdit() {
    this.editedDelegation = JSON.parse(JSON.stringify(this.delegation))
    this.formActive = true
  }

  async removeDelegation() {
    try {
      await api.delete(`bo/delegations/${this.delegation.id}`)
      this.$toast.open({
        message: "La délégation a bien été supprimée",
        type: "is-novaccess-purple",
        duration: 2000,
      })
      this.$router.push({ name: 'delegations' })
    } catch (e) {
      console.log(e)
    }
  }

  addBreadcrumb() {
    if (!this.delegation.id) return
    const crumb: any = document.querySelector(".breadcrumb .is-current")
    if (crumb) crumb.innerHTML = `délégation ${this.delegation.id}`
  }
}
